import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { singleton } from 'tsyringe';
import { ServiceType } from '@gn-audio/core/api/product-catalogue/enums/service-type';
import { getBasketIdFromUrl } from '../utilities/get-basket-id-from-url';
import { SFCCBasketService } from './sfcc-basket.service';
var BasketStore = /** @class */ (function () {
    function BasketStore(sfccBasketService) {
        this.sfccBasketService = sfccBasketService;
        this.basket = null;
        this.sharedBasket = null;
    }
    Object.defineProperty(BasketStore.prototype, "state", {
        /** Returns a copy of current basket state */
        get: function () {
            return Object.assign({}, this.basket);
        },
        enumerable: false,
        configurable: true
    });
    BasketStore.prototype.addProducts = function (skus, services, engravingMessage) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.sfccBasketService.addProducts(skus, services, engravingMessage)];
                    case 1:
                        _a.basket = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketStore.prototype.addProductsAsBasketItems = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.sfccBasketService.addProductsAsBasketItems(items)];
                    case 1:
                        _a.basket = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sets service sku, service value, and engravging message for basket item
     * @param itemId Basket item ID to set engraving message for
     * @param quantity Quantity of product
     * @param serviceSku SKU of the service
     * @param serviceValue Service message to add to the product
     * @param engravingMessage Engraving message for product
     * @remarks If empty engraving message is provided, it will be removed from the product
     */
    BasketStore.prototype.setServiceValue = function (itemId, quantity, serviceSku, serviceValue, engravingMessage) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.sfccBasketService.setServiceValue(itemId, quantity, serviceSku, serviceValue, engravingMessage)];
                    case 1:
                        _a.basket = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketStore.prototype.createSharedBasket = function (basket) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.basket;
                        return [4 /*yield*/, this.sfccBasketService.createSharedBasket(basket)];
                    case 1:
                        _a.customObjectKey = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketStore.prototype.getBasketByCustomObjectKey = function (basketCustomObjectKey) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.sfccBasketService.getBasketByCustomObjectKey(basketCustomObjectKey)];
                    case 1:
                        _a.sharedBasket = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketStore.prototype.createBasketFromOtherBasket = function (basketToTransfer) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.sfccBasketService.createBasketFromOtherBasket(basketToTransfer)];
                    case 1:
                        _a.basket = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketStore.prototype.applyCoupon = function (couponCode) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.sfccBasketService.applyCoupon(couponCode)];
                    case 1:
                        _a.basket = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketStore.prototype.setQuantity = function (itemId, sku, quantity) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.sfccBasketService.setQuantity(itemId, sku, quantity)];
                    case 1:
                        _a.basket = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketStore.prototype.removeProduct = function (itemId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.sfccBasketService.removeProduct(itemId)];
                    case 1:
                        _a.basket = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketStore.prototype.removeCoupon = function (couponItemId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.sfccBasketService.removeCoupon(couponItemId)];
                    case 1:
                        _a.basket = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketStore.prototype.getBasket = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.sfccBasketService.getBasket()];
                    case 1:
                        _a.basket = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketStore.prototype.restore = function () {
        return __awaiter(this, void 0, void 0, function () {
            var basketCustomObjectKey, currentBasket, restoredBasketItems, basketWithCoupons, error_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 9]);
                        basketCustomObjectKey = getBasketIdFromUrl();
                        return [4 /*yield*/, this.validateAndfetchBasket()];
                    case 1:
                        currentBasket = _b.sent();
                        if (!basketCustomObjectKey) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getBasketByCustomObjectKey(basketCustomObjectKey)];
                    case 2:
                        _b.sent();
                        if (!this.sharedBasket) {
                            return [2 /*return*/];
                        }
                        restoredBasketItems = this.getRestoredBasketItems(this.sharedBasket);
                        if (!(restoredBasketItems === null || restoredBasketItems === void 0 ? void 0 : restoredBasketItems.length)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.sfccBasketService.removeBasket(currentBasket.basket_id)];
                    case 3:
                        _b.sent();
                        if (!!!this.sharedBasket.coupon_items) return [3 /*break*/, 5];
                        basketWithCoupons = this.addCouponItems(this.sharedBasket.coupon_items);
                        return [4 /*yield*/, this.createBasketFromOtherBasket(basketWithCoupons)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [4 /*yield*/, this.addProductsAsBasketItems(restoredBasketItems)];
                    case 6:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 7:
                        error_1 = _b.sent();
                        // In case of any expcetions basket should work normally.
                        _a = this;
                        return [4 /*yield*/, this.sfccBasketService.getBasket()];
                    case 8:
                        // In case of any expcetions basket should work normally.
                        _a.basket = _b.sent();
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    BasketStore.prototype.getRestoredBasketItems = function (sharedBasket) {
        var _a;
        var productItems = [];
        (_a = sharedBasket.product_items) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.c_serviceType !== ServiceType.GiftWrapping; }).forEach(function (item) {
            var _a;
            var giftWrapping = (_a = sharedBasket.product_items) === null || _a === void 0 ? void 0 : _a.find(function (service) {
                var _a;
                return service.item_id &&
                    service.c_serviceType === ServiceType.GiftWrapping &&
                    ((_a = item.c_serviceIDs) === null || _a === void 0 ? void 0 : _a.includes(service.item_id));
            });
            var services = [];
            if (giftWrapping) {
                services.push({
                    sku: giftWrapping.product_id,
                    value: giftWrapping.c_serviceValue,
                });
            }
            var productItem = {
                sku: item.product_id,
                quantity: item.quantity,
                engravingMessage: item.c_engravingMsg,
                services: services,
            };
            productItems.push(productItem);
        });
        return productItems;
    };
    BasketStore.prototype.addCouponItems = function (couponItems) {
        return {
            coupon_items: couponItems,
            basket_id: '',
            c_localeID: '',
            c_order_discount_formatted: '',
            c_product_before_discount_formatted: '',
            c_product_sub_total_formatted: '',
            c_product_total_formatted: '',
            currency: '',
            product_total: 0,
            product_sub_total: 0,
        };
    };
    BasketStore.prototype.validateAndfetchBasket = function () {
        return __awaiter(this, void 0, void 0, function () {
            var productItems, _loop_1, this_1, _i, productItems_1, item;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBasket()];
                    case 1:
                        _a.sent();
                        productItems = this.basket.product_items;
                        if (!productItems) {
                            return [2 /*return*/, this.basket];
                        }
                        _loop_1 = function (item) {
                            var serviceMasterId_1, hasMasterProduct;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!item.c_serviceType) return [3 /*break*/, 2];
                                        serviceMasterId_1 = item.c_serviceMasterID;
                                        hasMasterProduct = productItems.find(function (potentialMasterItem) { return potentialMasterItem.item_id === serviceMasterId_1 && !potentialMasterItem.c_serviceType; });
                                        if (!!hasMasterProduct) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this_1.removeProduct(item.item_id)];
                                    case 1:
                                        _b.sent();
                                        _b.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _i = 0, productItems_1 = productItems;
                        _a.label = 2;
                    case 2:
                        if (!(_i < productItems_1.length)) return [3 /*break*/, 5];
                        item = productItems_1[_i];
                        return [5 /*yield**/, _loop_1(item)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, this.basket];
                }
            });
        });
    };
    BasketStore = __decorate([
        singleton(),
        __metadata("design:paramtypes", [SFCCBasketService])
    ], BasketStore);
    return BasketStore;
}());
export { BasketStore };
